import { render, staticRenderFns } from "./EdutalkPayment.vue?vue&type=template&id=52120a8c"
import script from "./EdutalkPayment.vue?vue&type=script&lang=js"
export * from "./EdutalkPayment.vue?vue&type=script&lang=js"
import style0 from "./EdutalkPayment.vue?vue&type=style&index=0&id=52120a8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports